import React from "react";
import "./Footer.css";
import logo from "../../../assets/images/Picture2.png";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Brand */}
        <div className="footer-col brand">
          <img src={logo} alt="Company Logo" className="footer-logo" />
          <p>
            An all-in-one HRM, Finance & Admin platform designed to simplify
            workforce management and drive business growth.
          </p>

          {/* Social Media */}
          <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaInstagram /></a>
          </div>
        </div>

        {/* HRM */}
        <div className="footer-col">
          <h4>HRM</h4>
          <ul>
            <li>Employee Management</li>
            <li>Attendance & Leave</li>
            <li>Payroll</li>
            <li>Performance</li>
            <li>HR Help Desk</li>
          </ul>
        </div>

        {/* Finance */}
        <div className="footer-col">
          <h4>Finance</h4>
          <ul>
            <li>Accounting</li>
            <li>Expense Management</li>
            <li>Invoices</li>
            <li>Budgeting</li>
            <li>Reports</li>
          </ul>
        </div>

        {/* Admin / Manager */}
        <div className="footer-col">
          <h4>Admin & Manager</h4>
          <ul>
            <li>User Roles</li>
            <li>Approvals</li>
            <li>Task Management</li>
            <li>Compliance</li>
            <li>Analytics</li>
          </ul>
        </div>

        {/* Location & Demo */}
        <div className="footer-col">
          <h4>Contact</h4>

          <div className="location">
            <FaMapMarkerAlt />
            <span>
              3rd Floor, Business Tower,<br />
              New Delhi, India
            </span>
          </div>

          <button className="demo-btn">
            Request a Demo
          </button>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Your Company Name. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
